import { varAlpha } from 'minimal-shared/utils';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

import { useTranslate } from 'src/locales';

// ----------------------------------------------------------------------

export function ButtonBlur({ text = '', sx, ...other }) {
  const { t } = useTranslate();

  return (
    <Box sx={[...(Array.isArray(sx) ? sx : [sx])]} {...other}>
      <Button
        sx={[
          (theme) => ({
            px: 3,
            color: theme.palette.common.white,
            ...theme.mixins.bgBlur({
              color: varAlpha(theme.vars.palette.grey['900Channel'], 0.24),
            }),
            '&:hover': {
              ...theme.mixins.bgBlur({
                color: varAlpha(theme.vars.palette.grey['900Channel'], 0.48),
              }),
            },
          }),
        ]}
      >
        {t(text)}
      </Button>
    </Box>
  );
}
